import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';

const CHECKOUT_CART_MESSAGES = {
  name: <FormattedMessage {...globalTranslations.productTitle} />,
  totalPrice: <FormattedMessage {...globalTranslations.totalPriceSentence} />,
  quantity: <FormattedMessage {...globalTranslations.quantityTitle} />,
};

const CheckoutCartHeader = ({ checkoutStore }) => {
  const { order } = checkoutStore;
  const isB2BCheckout = order?.isB2BCheckout ?? false;

  const renderProductHeaderCol = (label, sizes) => (
    <Col className="CheckoutCart__product-header" {...sizes}>
      {label}
    </Col>
  );

  const rowClassName = isB2BCheckout
    ? 'CheckoutCart__product-headers CheckoutCart__product-headers--b2b'
    : 'CheckoutCart__product-headers';

  return (
    <Row className={rowClassName}>
      {renderProductHeaderCol(CHECKOUT_CART_MESSAGES.name, { xl: 7 })}
      {renderProductHeaderCol(CHECKOUT_CART_MESSAGES.quantity, { xl: 3 })}
      {renderProductHeaderCol(CHECKOUT_CART_MESSAGES.totalPrice)}
    </Row>
  );
};

CheckoutCartHeader.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
};

export default inject('checkoutStore')(observer(CheckoutCartHeader));
